const ShoppingCart = require('od-modules/cart/cart');
const paymentButtonAttachment = require('../utils/attachment.storage');

const removeProductFromShoppingCartIfNeeded = ({model, onSuccess = () => {}}) => {
    const addedAtPaymentStep = ({source = {}}) =>
        ShoppingCart.sources.targets.CONTINUE_BUTTON === source.target;
    const productsToRemove = ShoppingCart.take.insurances(addedAtPaymentStep);
    productsToRemove.forEach(({name} = {}) => ShoppingCart.removeProduct(name));
    ShoppingCart.commit().then(() => {
        productsToRemove.forEach(({type}) => {
            Odigeo.trigger('payment-button:removeProductSuccess', {policyId: type});
        });
        onSuccess();
    });
};

const onRemoveProductSuccess = (callback = () => {}) => {
    paymentButtonAttachment.clear();
    callback();
};

const shouldRemoveProduct = () => paymentButtonAttachment.retry;

module.exports = {
    removeProductFromShoppingCartIfNeeded({model, onSuccess = () => {}}) {
        /* const successCallback = (removed, ...args) => {
            Odigeo._.partial(onSuccess, removed)(...args);
        }; */
        if (shouldRemoveProduct()) {
            removeProductFromShoppingCartIfNeeded({model, onSuccess: Odigeo._.partial(onSuccess, true)});
        } else {
            onRemoveProductSuccess(Odigeo._.partial(onSuccess, false));
        }
    },
};
